// app/javascript/controllers/details_controller.js
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["details"]

  connect() {
    console.log("Details controller connected");
    this.detailsTargets.forEach(details => {
      details.addEventListener('toggle', this.handleToggle.bind(this, details));
    });
  }

  handleToggle(details) {
    console.log("Toggled details:", details);
    if (details.open) {
      setTimeout(() => {
        const yOffset = -100; // Ajusta este valor según la altura deseada desde el inicio de la página
        const y = details.getBoundingClientRect().top + window.pageYOffset + yOffset;

        window.scrollTo({ top: y, behavior: 'smooth' });
      }, 100); // Delay to ensure the details have fully expanded
    }
  }
}
